module.exports = __webpack_public_path__ + "media/assets/service_bg-6c0292a5ea42242a923610ad0417ae50.jpg";